import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { headerEmpresa } from '../../helpers/headerEmpresa';
import { getEmpresa } from '../../../services/empresaService';
 // ajuste o caminho

async function RelatorioFichaTecnica(fichas){

  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  const empresa = await getEmpresa();

  const formatMoney = (v) => `R$ ${Number(v).toFixed(2)}`
  const formatPercent = (v) => `${Number(v).toFixed(0)}%`

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: [15, 60, 15, 40],

    header: headerEmpresa(empresa),

    content: [

      // ===== TÍTULO =====
      {
        text: 'Relatório de Ficha Técnica',
        style: 'titulo'
      },

      // ===== TABELA =====
      {
        table: {
          headerRows: 2,
          widths: [50, '*', 60, 60, 70, 60, 60, 70],
          body: [

            // LINHA 1 (AGRUPAMENTO)
            [
              { text: 'Cod Ficha', rowSpan: 2, style: 'tableHeader' },
              { text: 'Descrição', rowSpan: 2, style: 'tableHeader' },
              { text: 'Markup Desejado', rowSpan: 2, style: 'tableHeader' },
              { text: 'Custo Total', rowSpan: 2, style: 'tableHeader' },
              { text: 'Qtd Produção', rowSpan: 2, style: 'tableHeader' },
              { text: 'Valores Unitários', colSpan: 2, style: 'tableHeader', alignment: 'center' },
              {},
              { text: 'Markup Realizado', rowSpan: 2, style: 'tableHeader' }
            ],

            // LINHA 2 (SUBHEADER)
            [
              {}, {}, {}, {}, {},
              { text: 'Custo', style: 'tableHeader' },
              { text: 'Venda', style: 'tableHeader' },
              {}
            ],

            // DADOS
            ...fichas.map(item => ([
              item.COD_PRODUTO,
              item.DESCRICAO,
              formatPercent(item.MARKUP),
              formatMoney(item.COMPRA * item.QTD_RESULTADO), // custo total
              item.QTD_RESULTADO,
              formatMoney(item.COMPRA),
              formatMoney(item.VENDA),
              formatPercent(item.PERCENTUAL_LUCRO)
            ]))

          ]
        },

        layout: {
          fillColor: function (rowIndex) {
            return rowIndex < 2 ? '#eeeeee' : null;
          }
        },

        margin: [0, 10, 0, 0]
      }

    ],

    footer: (currentPage, pageCount) => ({
      text: `${currentPage} / ${pageCount}`,
      alignment: 'right',
      fontSize: 9,
      margin: [0, 10, 20, 0]
    }),

    styles: {
      titulo: {
        fontSize: 12,
        bold: true,
        alignment: 'center',
        margin: [0, 0, 0, 10]
      },
      tableHeader: {
        bold: true,
        fontSize: 9,
        alignment: 'center'
      }
    },

    defaultStyle: {
      fontSize: 9
    }
  };

  pdfMake.createPdf(docDefinition).open();
}

export default RelatorioFichaTecnica;